function hasCircuitNextRoundWorkoutSectionUtil (roundIndex, rounds) {
  return roundIndex < rounds.length - 1
}

export { hasCircuitNextRoundWorkoutSectionUtil }
